import { useContext } from 'react';
import { SnackbarContext } from 'components/theme/snackbar';

import { captureException } from '../../services/sentry';

export default function HandleGlobalError() {
  const { showSnackbar } = useContext(SnackbarContext);

  window.onerror = function handleGlobalError(message) {
    captureException(message);
    showSnackbar({
      message,
      options: { variant: 'error' }
    });

    return null;
  };

  return null;
}
